<template>
  <div class="file-upload">
    <form @submit.prevent="onSubmit">
      <div :class="'order-operation-notes-modal ' + (modal ? 'modal-card' : '')">
        <header class="modal-card-head" v-if="modal">
          <p class="modal-card-title has-text-weight-bold">
            {{ file ? "Update" : "Upload" }} File
          </p>
        </header>
        <section class="modal-card-body">
          <b-field label="Owner Type" v-if="!model">
            <b-select expanded v-model="form.ownerType" @input="fetchOwners" required>
              <option value>Please Select</option>
              <option value="firm">Firm</option>
              <!-- <option value="order">Order</option> -->
              <option value="person">Person</option>
            </b-select>
          </b-field>
          <b-field label="Owner" ref="selectOwner" v-if="!modelId">
            <b-select expanded :loading="fetchingOwners" v-model="form.owner" required>
              <option value>Please Select</option>
              <option :value="owner.id" v-for="owner in owners" :key="owner.id">
                {{
                  form.ownerType == "firm"
                    ? owner.name
                    : form.ownerType == "person"
                    ? owner.fullName
                    : owner.orderId
                }}
              </option>
            </b-select>
          </b-field>
          <b-field label="File"></b-field>
          <b-field v-if="file">
            <div>
              <template v-if="modal">

                <!-- <figure class="image is-3by3 is-inline-block"> -->

                  <img :src="file.thumbnail" v-if="file.mime.includes('image')" />

                  <file-iframe v-if="fileToDisplay" :fileToDisplay="fileToDisplay"></file-iframe>
                  <!-- <iframe :src="fileToDisplay" style="width:100%; height:40vh" frameborder="0" v-if="fileToDisplay"></iframe> -->

                  <!-- <b-icon
                    v-else
                    :icon="getIconByMimeType(file.mime)"
                    size="is-large"
                  /> -->

                <!-- </figure> -->

                <br /><br>
              </template>

              <p class="has-text-weight-semibold">
                {{ file.filename.replace(/^.*[\\\/]/, "") }}
              </p>
            </div>
          </b-field>
          <b-field class="file" v-else>
            <b-upload v-model="form.file" :accept="accept" name="file">
              <a class="button is-dark">
                <span>Choose file</span>
              </a>
            </b-upload>
            <span class="file-name">
              {{ form.file ? form.file.name : "No file chosen" }}
            </span>
          </b-field>
          <b-field label="Type">
            <b-select v-model="form.type" :disabled="!canManagedocuments" required>
              <option value>Please Select</option>
              <option
                :value="type.value"
                v-for="type in $options.types"
                :key="type.value"
              >
                {{ type.label }}
              </option>
            </b-select>
          </b-field>
          <!-- <tags-input
            label="Tags"
            :allow-new="true"
            :values.sync="form.tags"
            :disabled="!canManagedocuments"
          /> -->
          <base-tag-input :value.sync="form.tags" allow-new :disabled="!canManagedocuments" />
          <b-field label="Description">
            <b-input
              type="textarea"
              v-model="form.description"
              :disabled="!canManagedocuments"
              required
            />
          </b-field>


           <div v-if="canManagedocuments">

            <b-field label="Select who you want to see this document?"></b-field>

            <p v-for="(viewer, key) in viewers">

              <input type="checkbox" :value="viewer.id" v-model="form.viewers" disabled>

              <label class="viewer-label">{{ viewer.name }}</label>

            </p>

<!--             <div class="field" v-for="(viewer, key) in viewers">

              <b-checkbox  v-model="form.viewers" value="1">asd</b-checkbox>

            </div>
 -->

          </div>




        </section>
        <footer class="modal-card-foot">
          <b-button :disabled="loading || deleting" @click="$parent.close" v-if="modal">
            Cancel
          </b-button>
          <b-button
            type="is-danger"
            :disabled="loading"
            :loading="deleting"
            @click.prevent="confirmDelete"
            v-if="file && canManagedocuments"
          >
            Delete
          </b-button>
          <b-button
            type="is-primary"
            :disabled="loading || deleting"
            @click.prevent="replace"
            v-if="file && canManagedocuments"
          >
            Replace
          </b-button>
          <b-button
            type="is-info"
            native-type="submit"
            :disabled="deleting"
            :loading="loading"
          >
            {{ file ? "Update" : "Upload" }}
          </b-button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>

import { TagService } from "@/services/tag.service";


import { FileService } from "@/services/file.service";
import { FirmService } from "@/services/firm.service";
import { OrderService } from "@/services/order.service";
import { UserService } from "@/services/user.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import debounce from "lodash/debounce";
import TagsInput from "@/components/partials/TagsInput";
import FileIframe from "./FileIframe";
import BaseTagInput from "@/components/partials/BaseTagInput";

export default {
  fileService: FileService,
  firmService: FirmService,
  orderService: OrderService,
  userService: UserService,
  types: [
    {
      value: "Report",
      label: "Report"
    },
    {
      value: "Photo",
      label: "Photograph"
    },
    {
      value: "Checklist",
      label: "Checklist"
    },
    {
      value: "Site Notes",
      label: "Site Notes"
    }
  ],
  props: {
    file: {
      type: Object
    },
    model: {
      type: String
    },
    modelId: {
      type: String | Number
    },
    accept: {
      type: String
    },
    acceptedMimeTypes: {
      type: Array,
      default: () => []
    },
    modal: {
      type: Boolean,
      default: true
    },
    viewers: {
      type: Array,
      default: () => []
    },
    fileToDisplay: {
      type: String
    }
  },
  components: {
    TagsInput,
    FileIframe,
    BaseTagInput,
  },
  data: () => ({
    form: {
      ownerType: "",
      owner: "",
      file: null,
      type: "",
      description: "",
      tags: null,
      viewers: []
    },
    originalFile: undefined,
    owners: [],
    loading: false,
    deleting: false,
    fetchingOwners: false,

  }),
  computed: {
    user() {
      return this.$store.state.Auth.user;
    },
    canManagedocuments() {
      if (!this.file) return true;
      return this.$store.getters["Auth/hasPermission"]("can manage documents");
    }
  },
  mounted() {
    this.setForm();
  },
  watch: {
    file() {
      this.setForm();
    }
  },
  methods: {
    setForm() {

      if (this.file) {
        this.form = {
          ownerType: this.model || "",
          owner: this.modelId || "",
          type: this.file.subtype,
          description: this.file.description,
          tags: this.file.tags.map(tag => {
            return tag.name;
          }).filter(element => { return element.toLowerCase() != 'vendor' && element.toLowerCase() != 'customer' && element.toLowerCase() != 'colleagues'; }),
          viewers: this.file.tags.filter(element => element.name.toLowerCase() == 'vendor' || element.name.toLowerCase() == 'customer' || element.name.toLowerCase() == 'colleagues')
                   .map(element => element.id)
        };
      } else {
        this.resetForm();
      }
    },
    resetForm() {
      this.form = {
        ownerType: this.model || "",
        owner: this.modelId || "",
        file: null,
        type: "",
        description: "",
        tags: null,
        viewers: this.viewers.map(element => element.id)
      };
    },
    async upload() {
      if (this.form.file && this.acceptedMimeTypes.length) {
        const mimeType = this.form.file.type;

        if (!this.acceptedMimeTypes.includes(mimeType)) {
          this.$buefy.toast.open({
            message: "Invalid file type.",
            type: "is-danger",
            position: "is-top-right"
          });
          return;
        }
      }

      const data = new FormData();

      data.append("model", this.form.ownerType);
      data.append("modelId", this.form.owner);

      if (this.originalFile) {
        data.append("original_file_id", this.originalFile);
      }

      if (this.form.file) {
        data.append("file", this.form.file);
      }

      if (this.form.type) {
        data.append("subtype", this.form.type);
      }

      if (this.form.description) {
        data.append("description", this.form.description);
      }

      if (this.form.tags) {
        this.form.tags.forEach(tag => {
          data.append("tags[]", tag);
        });
      }

      // let viewers = [];

      // Object.entries(this.form.viewers).forEach(viewer => {
      //   viewers.push(viewer);
      // });

      if (this.form.viewers) {
        this.form.viewers.forEach(viewer => {
          data.append("viewers[]", viewer);
        });
      }

      this.loading = true;

      try {
        const file = await this.$options.fileService
          .uploadFile(data)
          .then(response => JsonDenormalizer.denormalize(response));

        this.$buefy.toast.open({
          message: "File has been uploaded.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("uploaded", file);
        this.$parent.close();
      } catch (err) {}

      this.loading = false;
    },
    async update() {
      const data = {
        subtype: this.form.type,
        description: this.form.description,
        tags: this.form.tags,
        viewers: this.form.viewers
      };

      this.loading = true;

      try {
        let file = await this.$options.fileService
          .update(this.file.id, data)
          .then(response => JsonDenormalizer.denormalize(response));

        this.$buefy.toast.open({
          message: "File has been updated.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("updated", file);
        this.$parent.close();
      } catch (err) {}

      this.loading = false;
    },
    replace() {
      this.originalFile = this.file.id;

      const form = {
        ownerType: this.model || "",
        owner: this.modelId || "",
        type: this.file.subtype,
        description: this.file.description,
        tags: this.file.tags.map(tag => {
          return tag.name;
        }),
        viewers: this.file.viewers
      };

      // Clear defaults
      this.$emit("update:file", undefined);
      this.$emit("update:model", undefined);
      this.$emit("update:modelId", undefined);

      this.$nextTick(async () => {
        this.form = JSON.parse(JSON.stringify(form));
        await this.fetchOwners();
        this.form.owner = form.owner;
      });
    },
    confirmDelete() {
      this.$buefy.dialog.confirm({
        title: "Delete file",
        message:
          "Are you sure you want to <b>delete</b> this file? This action cannot be undone.",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.delete()
      });
    },
    async delete() {
      this.deleting = true;

      try {
        await this.$options.fileService.delete(this.file.id);

        this.$buefy.toast.open({
          message: "File has been deleted.",
          type: "is-info",
          position: "is-top-right"
        });

        this.$emit("deleted", this.file);
        this.$parent.close();
      } catch (err) {}

      this.deleting = false;
    },
    async fetchOwners() {
      this.owners = [];
      this.form.owner = "";

      this.fetchingOwners = true;

      switch (this.form.ownerType) {
        case "firm":
          await this.$options.firmService.all().then(response => {
            this.owners = JsonDenormalizer.denormalize(response);
          });
          break;
        case "order":
          await this.$options.orderService
            .all({ order_by: "id", sort_by: "asc", paginate: false })
            .then(response => {
              this.owners = JsonDenormalizer.denormalize(response);
            });
          break;
        case "person":
          await this.$options.userService
            .all({ firmId: this.user.firmId, archived: false, filter_by: 'first_name', order_by: 'asc' })
            .then(response => {
              this.owners = JsonDenormalizer.denormalize(response);
            });
          break;
      }

      this.fetchingOwners = false;
    },
    getIconByMimeType(mime) {
      if (mime.includes("image")) {
        return "file-image-o";
      } else if (mime.includes("pdf")) {
        return "file-pdf-o";
      } else if (mime.includes("msword") || mime.includes("word")) {
        return "file-word-o";
      } else if (mime.includes("zip") || mime.includes("rar")) {
        return "file-archive-o";
      } else if (mime.includes("ms-excel") || mime.includes("sheet")) {
        return "file-excel-o";
      } else if (
        mime.includes("ms-powerpoint") ||
        mime.includes("presentation")
      ) {
        return "file-powerpoint-o";
      } else if (mime.includes("text/plain")) {
        return "file-text-o";
      } else {
        return "file";
      }
    },
    onSubmit() {
      if (this.file) {
        this.update();
      } else {
        this.upload();
      }
    },

  }
};
</script>

<style scoped>

.viewer-label {
  /*position: absolute;*/
  /*margin: -2px 10px;*/
}

</style>


// WEBPACK FOOTER //
// src/components/File/FileModal.vue